import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Text, Tag } from 'src/components/matchbox';

export const StyledIcon = styled.span`
  display: inline-block;
  margin-left: ${({ theme }) => theme.space[100]};
  transform: translateY(-1px);
`;

export const MetricsWrapper = styled.div``;

export const FiltersBar = styled.div`
  display: grid;
  grid-gap: ${(props) => props.theme.space['400']};
  grid-template-columns: 1fr;

  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    grid-gap: ${(props) => props.theme.space['500']};
    grid-template-columns: 1fr 1fr 280px; /* NOTE: AlignedTextButton gets max width at the same time for this grid layout to work */
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  & > * {
    margin-bottom: 0;
  }
`;

export const Label = ({ children }: PropsWithChildren<{}>): JSX.Element => (
  <Text fontWeight="medium">{children}</Text>
);

export const NotificationTag = ({ enabled }: { enabled?: boolean }): JSX.Element =>
  enabled ? (
    <Tag color="lightGray">Notification Enabled</Tag>
  ) : (
    <Tag color="darkGray">Notification Disabled</Tag>
  );
